const WarningTriangle = (props) => {
  const { color, prioridade, btn } = props

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        background: `linear-gradient(90deg, #${color}90, #FFFFFF00)`,
        display: 'flex',
        gap: '16px',
        alignItems: 'center',
        marginLeft: '-32px',
        // paddingLeft: '32px',
        justifyContent: 'center'
      }}
    >
      {prioridade !== 0 &&
        <div>
          <svg width='20' height='20' viewBox='0 0 20 20'>
            <path
              d='M10 0 Q15 10 20 18 L18 20 H2 L0 18 Q5 10 10 0 Z'
              fill={`#${color}`}
              // stroke='#DEE2E6'
              stroke='#000'
              strokeWidth='1'
            />
            <text
              x='10'
              y='14'
              fill={color === '1a1a1a' ? '#FFF' : '#000'}
              fontSize='6'
              fontWeight='900'
              textAnchor='middle'
              alignmentBaseline='middle'
            >
              !
            </text>
          </svg>
        </div>
      }
      {btn}
    </div>
  );
}

export default WarningTriangle;
